// Parse various common date formats and return a UTC ISO string (to be sent to backend).
// This utility assumes pasted dates are in the browser's local timezone.
function parseDateToUtcIso(value) {
  if (value == null) return null;
  const s = String(value).trim();
  if (s === '') return null;

  // ISO with timezone or Z
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(s)) {
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d.toISOString();
  }

  // ISO without timezone (assume local): YYYY-MM-DDTHH:mm:ss
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(s)) {
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d.toISOString();
  }

  // YYYY-MM-DD or YYYY/MM/DD -> treat as local start-of-day
  if (/^\d{4}[/-]\d{2}[/-]\d{2}$/.test(s)) {
    const d = new Date(s + 'T00:00:00');
    return isNaN(d.getTime()) ? null : d.toISOString();
  }

  // DD/MM/YYYY or DD-MM-YYYY -> common spreadsheet format (assume day/month/year)
  if (/^\d{2}[/-]\d{2}[/-]\d{4}$/.test(s)) {
    const parts = s.split(/[/-]/);
    const day = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const year = Number(parts[2]);
    const d = new Date(year, month, day, 0, 0, 0);
    return isNaN(d.getTime()) ? null : d.toISOString();
  }

  // Fallback: let Date parse it
  const d = new Date(s);
  if (!isNaN(d.getTime())) return d.toISOString();

  return null;
}

export default parseDateToUtcIso;
